import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { getCurrentDiagnosisUser } from '../../../redux/selectors/hairDiagnosis';

import {
  Button,
  ButtonContainer,
  ContentContainer,
  CurrentPage,
  VisitDate,
  Item,
  Navigation,
  NextPage,
  SalonActivities,
  Stylist,
  Title,
  VisitsContainer,
  PlusIcon,
  TextIcon,
  Wrapper,
  AddNewVisitWrapper,
} from './SalonVisitsPage.style';

class SalonVisitsPage extends Component {
  componentDidMount() {
    const { currentDiagnosisUser, history, locale } = this.props;

    if (!currentDiagnosisUser) {
      history.push(`/${locale}/stylist/retrieve-profile`);
    }
  }

  render() {
    const { locale, currentDiagnosisUser, copy } = this.props;
    const currentDate = new Date();
    return (
      <Wrapper>
        <Navigation>
          <CurrentPage>{copy.salon_visit}</CurrentPage>
          <NextPage>
            <Link to={`/${locale}/stylist/profile`} href={`/${locale}/stylist/profile`}>
              {copy.customer_profile}
            </Link>
          </NextPage>
        </Navigation>
        <AddNewVisitWrapper>
          <Item>
            <ContentContainer>
              <VisitDate>
                {currentDate.getDate()}/{currentDate.getMonth() + 1}/{currentDate.getFullYear()}
              </VisitDate>
              <Title>{copy.add_new_salon_visit}</Title>
            </ContentContainer>
            <ButtonContainer>
              <Button>
                <Link to={`/${locale}/stylist/new-visit`} href={`/${locale}/stylist/new-visit`}>
                  <PlusIcon />
                </Link>
              </Button>
            </ButtonContainer>
          </Item>
        </AddNewVisitWrapper>

        {currentDiagnosisUser &&
          currentDiagnosisUser.salonVisits.length > 0 && (
            <VisitsContainer>
              {currentDiagnosisUser.salonVisits
                .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
                .map(salonVisit => {
                  const lastUpdated = new Date(salonVisit.updatedAt);
                  return (
                    <Fragment key={salonVisit.createdAt}>
                      <Item>
                        <ContentContainer>
                          <VisitDate>
                            {lastUpdated.getDate()}/{lastUpdated.getMonth() + 1}/{lastUpdated.getFullYear()}
                          </VisitDate>
                          {salonVisit.stylist && (
                            <Stylist>
                              {salonVisit.stylist.given_name} {salonVisit.stylist.family_name} /{' '}
                              {salonVisit.stylist.city} {salonVisit.stylist.salon}
                            </Stylist>
                          )}

                          <SalonActivities>
                            {salonVisit.hairCut && copy.hair_cut}
                            {salonVisit.hairColorRecipes.length > 0 && ` | ${copy.hair_color}`}
                            {salonVisit.hairTreatment && ` | ${copy.treatment}`}
                            {salonVisit.headSpa && ` | ${copy.head_spa}`}
                            {salonVisit.perm && ` | ${copy.perm}`}
                            {salonVisit.hairStraightening && ` | ${copy.hair_straightening}`}
                          </SalonActivities>
                        </ContentContainer>
                        <ButtonContainer>
                          <Button>
                            <Link
                              to={`/${locale}/stylist/visit/${salonVisit.id}`}
                              href={`/${locale}/stylist/visit/${salonVisit.id}`}
                            >
                              <TextIcon />
                            </Link>
                          </Button>
                        </ButtonContainer>
                      </Item>
                    </Fragment>
                  );
                })}
            </VisitsContainer>
          )}
      </Wrapper>
    );
  }
}

SalonVisitsPage.defaultProps = {
  currentDiagnosisUser: null,
  copy: {
    perm: 'Perm',
    hair_cut: 'Hair Cut',
    head_spa: 'Head Spa',
    treatment: 'Treatment',
    hair_color: 'Hair Color',
    salon_visit: 'Salon Visit',
    customer_profile: 'Customer Profile',
    hair_straightening: 'Hair Straightening',
    add_new_salon_visit: 'Add new salon visit',
  },
};

SalonVisitsPage.propTypes = {
  locale: PropTypes.string.isRequired,
  currentDiagnosisUser: PropTypes.shape({}),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  copy: PropTypes.shape({}),
};

const mapState = state => ({
  locale: state.locale,
  currentDiagnosisUser: getCurrentDiagnosisUser(state),
  copy: state.siteOptions.siteCopyStylistToolSalonVisitsPage,
});

export default connect(mapState)(SalonVisitsPage);



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/SalonVisitsPage/SalonVisitsPage.js